import React from "react";

export const StepCircle = ({ status }) => {
    const isDoneOrCurrent = status === 'done' || status === 'current';
    const fillColor = isDoneOrCurrent ? 'var(--asset-step-circle-active-fill)' : 'var(--asset-step-circle-inactive-fill)';
    const strokeGradientId = isDoneOrCurrent
        ? 'paint0_linear_active'
        : 'paint0_linear_inactive';

    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="34"
            height="34"
            viewBox="0 0 34 34"
            fill="none"
        >
            <g filter="url(#filter0_i_461_17504)">
                <circle cx="17" cy="17" r="17" fill={fillColor} />
            </g>
            <circle
                cx="17"
                cy="17"
                r="16"
                stroke={`url(#${strokeGradientId})`}
                strokeWidth="2"
            />
            {/* white check for done & current */}
            {isDoneOrCurrent && (
                <path
                    d="M13 17.5L15.5 20L21 14.5"
                    stroke="var(--asset-step-circle-check)"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            )}
            <defs>
                {/* your original filter, unchanged */}
                <filter
                    id="filter0_i_461_17504"
                    x="0"
                    y="0"
                    width="38"
                    height="38"
                    filterUnits="userSpaceOnUse"
                    colorInterpolationFilters="sRGB"
                >
                    <feFlood floodOpacity="0" result="BackgroundImageFix" />
                    <feBlend
                        in="SourceGraphic"
                        in2="BackgroundImageFix"
                        result="shape"
                        mode="normal"
                    />
                    <feColorMatrix
                        in="SourceAlpha"
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                        result="hardAlpha"
                    />
                    <feOffset dx="6" dy="7" />
                    <feGaussianBlur stdDeviation="2" />
                    <feComposite
                        in2="hardAlpha"
                        operator="arithmetic"
                        k2="-1"
                        k3="1"
                    />
                    <feColorMatrix
                        type="matrix"
                        values="0 0 0 0 0.027451 0 0 0 0 0.0666667 0 0 0 0 0.156863 0 0 0 0.3 0"
                    />
                    <feBlend
                        in2="shape"
                        result="effect1_innerShadow_461_17504"
                        mode="normal"
                    />
                </filter>

                {/* active gradient from your snippet */}
                <linearGradient
                    id="paint0_linear_active"
                    x1="29.0417"
                    y1="30.7734"
                    x2="3.93489"
                    y2="5.66667"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="var(--asset-step-circle-active-gradient-start)" stopOpacity="0.5" />
                    <stop
                        offset="1"
                        stopColor="var(--asset-step-circle-active-gradient-end)"
                        stopOpacity="0.51"
                    />
                </linearGradient>

                {/* slightly muted gradient for upcoming steps */}
                <linearGradient
                    id="paint0_linear_inactive"
                    x1="29.0417"
                    y1="30.7734"
                    x2="3.93489"
                    y2="5.66667"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="var(--asset-step-circle-inactive-gradient-start)" stopOpacity="0.4" />
                    <stop offset="1" stopColor="var(--asset-step-circle-inactive-gradient-end)" stopOpacity="0.5" />
                </linearGradient>
            </defs>
        </svg>
    );
};


export const AssetCardMainIcon = () => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="48"
        height="48"
        viewBox="0 0 72 72"
        fill="none"
    >
        <path
            d="M47.868 22.2642H23.3774C22.7626 22.2642 22.2642 22.7626 22.2642 23.3774V47.868C22.2642 48.4828 22.7626 48.9812 23.3774 48.9812H47.868C48.4828 48.9812 48.9812 48.4828 48.9812 47.868V23.3774C48.9812 22.7626 48.4828 22.2642 47.868 22.2642Z"
            fill="var(--asset-main-icon)"
        />
        <path
            d="M64.5662 26.717C65.1567 26.717 65.723 26.4825 66.1405 26.0649C66.558 25.6474 66.7926 25.0811 66.7926 24.4906C66.7926 23.9001 66.558 23.3338 66.1405 22.9163C65.723 22.4988 65.1567 22.2642 64.5662 22.2642H62.3398V17.8113C62.3372 15.4502 61.3981 13.1865 59.7285 11.5169C58.0589 9.84735 55.7952 8.90825 53.4341 8.90567H48.9813V6.67925C48.9813 6.08877 48.7467 5.52247 48.3292 5.10494C47.9116 4.6874 47.3453 4.45284 46.7548 4.45284C46.1644 4.45284 45.5981 4.6874 45.1805 5.10494C44.763 5.52247 44.5284 6.08877 44.5284 6.67925V8.90567H37.8492V6.67925C37.8492 6.08877 37.6146 5.52247 37.1971 5.10494C36.7795 4.6874 36.2132 4.45284 35.6227 4.45284C35.0323 4.45284 34.466 4.6874 34.0484 5.10494C33.6309 5.52247 33.3963 6.08877 33.3963 6.67925V8.90567H26.7171V6.67925C26.7171 6.08877 26.4825 5.52247 26.065 5.10494C25.6474 4.6874 25.0811 4.45284 24.4907 4.45284C23.9002 4.45284 23.3339 4.6874 22.9163 5.10494C22.4988 5.52247 22.2642 6.08877 22.2642 6.67925V8.90567H17.8114C15.4503 8.90825 13.1866 9.84735 11.517 11.5169C9.8474 13.1865 8.9083 15.4502 8.90572 17.8113V22.2642H6.6793C6.08882 22.2642 5.52252 22.4988 5.10498 22.9163C4.68745 23.3338 4.45288 23.9001 4.45288 24.4906C4.45288 25.0811 4.68745 25.6474 5.10498 26.0649C5.52252 26.4825 6.08882 26.717 6.6793 26.717H8.90572V33.3963H6.6793C6.08882 33.3963 5.52252 33.6308 5.10498 34.0484C4.68745 34.4659 4.45288 35.0322 4.45288 35.6227C4.45288 36.2132 4.68745 36.7795 5.10498 37.197C5.52252 37.6146 6.08882 37.8491 6.6793 37.8491H8.90572V44.5284H6.6793C6.08882 44.5284 5.52252 44.7629 5.10498 45.1805C4.68745 45.598 4.45288 46.1643 4.45288 46.7548C4.45288 47.3453 4.68745 47.9116 5.10498 48.3291C5.52252 48.7466 6.08882 48.9812 6.6793 48.9812H8.90572V53.4341C8.9083 55.7952 9.8474 58.0589 11.517 59.7285C13.1866 61.398 15.4503 62.3372 17.8114 62.3397H22.2642V64.5661C22.2642 65.1566 22.4988 65.7229 22.9163 66.1405C23.3339 66.558 23.9002 66.7926 24.4907 66.7926C25.0811 66.7926 25.6474 66.558 26.065 66.1405C26.4825 65.7229 26.7171 65.1566 26.7171 64.5661V62.3397H33.3963V64.5661C33.3963 65.1566 33.6309 65.7229 34.0484 66.1405C34.466 66.558 35.0323 66.7926 35.6227 66.7926C36.2132 66.7926 36.7795 66.558 37.1971 66.1405C37.6146 65.7229 37.8492 65.1566 37.8492 64.5661V62.3397H44.5284V64.5661C44.5284 65.1566 44.763 65.7229 45.1805 66.1405C45.5981 66.558 46.1644 66.7926 46.7548 66.7926C47.3453 66.7926 47.9116 66.558 48.3292 66.1405C48.7467 65.7229 48.9813 65.1566 48.9813 64.5661V62.3397H53.4341C55.7952 62.3372 58.0589 61.398 59.7285 59.7285C61.3981 58.0589 62.3372 55.7952 62.3398 53.4341V48.9812H64.5662C65.1567 48.9812 65.723 48.7466 66.1405 48.3291C66.558 47.9116 66.7926 47.3453 66.7926 46.7548C66.7926 46.1643 66.558 45.598 66.1405 45.1805C65.723 44.7629 65.1567 44.5284 64.5662 44.5284H62.3398V37.8491H64.5662C65.1567 37.8491 65.723 37.6146 66.1405 37.197C66.558 36.7795 66.7926 36.2132 66.7926 35.6227C66.7926 35.0322 66.558 34.4659 66.1405 34.0484C65.723 33.6308 65.1567 33.3963 64.5662 33.3963H62.3398V26.717H64.5662ZM53.4341 48.9812C53.4341 50.1622 52.965 51.2948 52.1299 52.1298C51.2948 52.9649 50.1622 53.4341 48.9813 53.4341H22.2642C21.0833 53.4341 19.9507 52.9649 19.1156 52.1298C18.2805 51.2948 17.8114 50.1622 17.8114 48.9812V22.2642C17.8114 21.0832 18.2805 19.9506 19.1156 19.1156C19.9507 18.2805 21.0833 17.8113 22.2642 17.8113H48.9813C50.1622 17.8113 51.2948 18.2805 52.1299 19.1156C52.965 19.9506 53.4341 21.0832 53.4341 22.2642V48.9812Z"
            fill="var(--asset-main-icon)"
        />
    </svg>
);

export const IdentificationIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
        <path
            d="M10.0001 18.3333C14.6025 18.3333 18.3334 14.6024 18.3334 9.99999C18.3334 5.39762 14.6025 1.66666 10.0001 1.66666C5.39771 1.66666 1.66675 5.39762 1.66675 9.99999C1.66675 14.6024 5.39771 18.3333 10.0001 18.3333Z"
            stroke="var(--asset-info-icon)"
            strokeWidth="1.66667"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path d="M10 13.3333V10" stroke="var(--asset-info-icon)" strokeWidth="1.66667" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M10 6.66666H10.0083" stroke="var(--asset-info-icon)" strokeWidth="1.66667" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
);

export const OperationalIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
        <path
            d="M18.3332 9.99999H16.2665C15.9023 9.99921 15.5479 10.1177 15.2574 10.3375C14.967 10.5572 14.7565 10.866 14.6582 11.2167L12.6998 18.1833C12.6872 18.2266 12.6609 18.2646 12.6248 18.2917C12.5888 18.3187 12.5449 18.3333 12.4998 18.3333C12.4548 18.3333 12.4109 18.3187 12.3748 18.2917C12.3388 18.2646 12.3125 18.2266 12.2998 18.1833L7.69984 1.81666C7.68722 1.77338 7.6609 1.73537 7.62484 1.70832C7.58878 1.68128 7.54491 1.66666 7.49984 1.66666C7.45476 1.66666 7.4109 1.68128 7.37484 1.70832C7.33878 1.73537 7.31246 1.77338 7.29984 1.81666L5.3415 8.78332C5.24356 9.13262 5.03432 9.44042 4.74556 9.66C4.45679 9.87958 4.10427 9.99895 3.7415 9.99999H1.6665"
            stroke="var(--asset-info-icon)"
            strokeWidth="1.66667"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);

export const PowerIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
        <path
            d="M2.6665 9.33334C2.54034 9.33377 2.41665 9.2984 2.3098 9.23133C2.20295 9.16426 2.11732 9.06824 2.06287 8.95445C2.00841 8.84065 1.98736 8.71373 2.00217 8.58845C2.01697 8.46316 2.06702 8.34465 2.1465 8.24667L8.7465 1.44667C8.79601 1.38953 8.86347 1.35091 8.93782 1.33716C9.01217 1.32341 9.08898 1.33535 9.15565 1.37101C9.22232 1.40667 9.27489 1.46394 9.30472 1.53341C9.33456 1.60289 9.33988 1.68044 9.31983 1.75334L8.03983 5.76667C8.00209 5.86769 7.98941 5.97635 8.00289 6.08334C8.01637 6.19034 8.05561 6.29246 8.11723 6.38096C8.17885 6.46946 8.26101 6.54168 8.35668 6.59145C8.45235 6.64121 8.55866 6.66702 8.6665 6.66667H13.3332C13.4593 6.66624 13.583 6.70162 13.6899 6.76869C13.7967 6.83576 13.8823 6.93177 13.9368 7.04557C13.9913 7.15937 14.0123 7.28628 13.9975 7.41157C13.9827 7.53685 13.9326 7.65537 13.8532 7.75334L7.25317 14.5533C7.20366 14.6105 7.13619 14.6491 7.06184 14.6629C6.9875 14.6766 6.91068 14.6647 6.84401 14.629C6.77734 14.5933 6.72478 14.5361 6.69494 14.4666C6.66511 14.3971 6.65978 14.3196 6.67983 14.2467L7.95983 10.2333C7.99758 10.1323 8.01025 10.0237 7.99677 9.91667C7.98329 9.80968 7.94406 9.70755 7.88244 9.61906C7.82082 9.53056 7.73865 9.45833 7.64298 9.40857C7.54731 9.3588 7.441 9.33299 7.33317 9.33334H2.6665Z"
            stroke="var(--asset-power-icon)"
            strokeWidth="1.33333"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);

export const VoltageIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
        <path
            d="M8 9.33332L10.6667 6.66666"
            stroke="var(--asset-voltage-icon)"
            strokeWidth="1.33333"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M2.22683 12.6667C1.64164 11.6532 1.33354 10.5036 1.3335 9.3333C1.33345 8.16303 1.64146 7.01336 2.22658 5.99986C2.81169 4.98636 3.65328 4.14474 4.66676 3.55959C5.68023 2.97444 6.82989 2.66638 8.00016 2.66638C9.17044 2.66638 10.3201 2.97444 11.3336 3.55959C12.347 4.14474 13.1886 4.98636 13.7737 5.99986C14.3589 7.01336 14.6669 8.16303 14.6668 9.3333C14.6668 10.5036 14.3587 11.6532 13.7735 12.6667"
            stroke="var(--asset-voltage-icon)"
            strokeWidth="1.33333"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);

export const EfficiencyIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
        <path
            d="M10.6665 4.66669H14.6665V8.66669"
            stroke="var(--asset-efficiency-icon)"
            strokeWidth="1.33333"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M14.6668 4.66669L9.00016 10.3334L5.66683 7.00002L1.3335 11.3334"
            stroke="var(--asset-efficiency-icon)"
            strokeWidth="1.33333"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);

export const CapacityIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
        <path
            d="M14.6665 9.33335V6.66669"
            stroke="var(--asset-capacity-icon)"
            strokeWidth="1.33333"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M10.6668 4H2.66683C1.93045 4 1.3335 4.59695 1.3335 5.33333V10.6667C1.3335 11.403 1.93045 12 2.66683 12H10.6668C11.4032 12 12.0002 11.403 12.0002 10.6667V5.33333C12.0002 4.59695 11.4032 4 10.6668 4Z"
            stroke="var(--asset-capacity-icon)"
            strokeWidth="1.33333"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);

export const MaintenanceIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
        <path
            d="M12.25 5.25005C12.0973 5.40582 12.0118 5.61525 12.0118 5.83338C12.0118 6.05151 12.0973 6.26094 12.25 6.41671L13.5833 7.75004C13.7391 7.90273 13.9485 7.98826 14.1666 7.98826C14.3848 7.98826 14.5942 7.90273 14.75 7.75004L17.3383 5.16255C17.605 4.89421 18.0575 4.97921 18.1575 5.34421C18.4093 6.25994 18.395 7.22844 18.1165 8.13637C17.8379 9.04431 17.3065 9.85413 16.5845 10.4711C15.8624 11.088 14.9796 11.4866 14.0394 11.6201C13.0991 11.7536 12.1402 11.6166 11.275 11.225L4.68332 17.8167C4.35179 18.1481 3.9022 18.3343 3.43344 18.3342C2.96467 18.3341 2.51514 18.1478 2.18373 17.8163C1.85232 17.4848 1.66618 17.0352 1.66626 16.5664C1.66634 16.0977 1.85263 15.6481 2.18415 15.3167L8.77582 8.72505C8.38427 7.85981 8.24724 6.90095 8.38076 5.96067C8.51428 5.02039 8.91284 4.13759 9.52978 3.41556C10.1467 2.69353 10.9566 2.16214 11.8645 1.88357C12.7724 1.605 13.7409 1.59077 14.6566 1.84254C15.0216 1.94254 15.1066 2.39421 14.8391 2.66254L12.25 5.25005Z"
            stroke="var(--asset-info-icon)"
            strokeWidth="1.66667"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);



export const CurrentIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
  <path d="M12.8335 8.16668V5.83334" stroke="var(--asset-capacity-icon)" stroke-width="1.16667" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M9.33317 3.5H2.33317C1.68884 3.5 1.1665 4.02233 1.1665 4.66667V9.33333C1.1665 9.97767 1.68884 10.5 2.33317 10.5H9.33317C9.9775 10.5 10.4998 9.97767 10.4998 9.33333V4.66667C10.4998 4.02233 9.9775 3.5 9.33317 3.5Z" stroke="var(--asset-capacity-icon)" stroke-width="1.16667" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
);